var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerDoubleDownLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0859 1.46967C17.793 1.17678 17.3181 1.17678 17.0252 1.46967L12.5808 5.91411C12.3663 6.12861 12.3021 6.4512 12.4182 6.73146C12.5343 7.01171 12.8078 7.19444 13.1111 7.19444H16.8056V14.2222C16.8056 15.649 15.649 16.8056 14.2222 16.8056H7.19444V13.1111C7.19444 12.8078 7.01171 12.5343 6.73146 12.4182C6.4512 12.3021 6.12861 12.3663 5.91411 12.5808L1.46967 17.0252C1.17678 17.3181 1.17678 17.793 1.46967 18.0859L5.91411 22.5303C6.12861 22.7448 6.4512 22.809 6.73146 22.6929C7.01171 22.5768 7.19444 22.3033 7.19444 22V18.3056H14.2222C16.4774 18.3056 18.3056 16.4774 18.3056 14.2222V7.19444H22C22.3033 7.19444 22.5768 7.01171 22.6929 6.73146C22.809 6.4512 22.7448 6.12861 22.5303 5.91411L18.0859 1.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDoubleDownLeft);
export default __webpack_public_path__ + "static/media/corner-double-down-left.f575498f208154531c9d50c5be6295bf.svg";
export { ForwardRef as ReactComponent };